module.exports = __webpack_public_path__ + "media/images/home/money-7069dc162e4e5197503d671cb3cb013a.png";